<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          :placeholder="$t('app.card.companyName')"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false,multiple: true }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userIds"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" :placeholder="$t('app.card.iccidPlaceholder')"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'iccid')"></el-input>
      </el-form-item>
      <el-form-item  prop="msisdn">
        <el-input v-model="queryParams.msisdn" :placeholder="$t('app.card.msisdnPlaceholder')"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'msisdn')"></el-input>
      </el-form-item>
      <template v-if="showSearch">
        <el-form-item  prop="imsi">
          <el-input v-model="queryParams.imsi" :placeholder="$t('app.card.imsiPlaceholder')"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'imsi')"></el-input>
        </el-form-item>
        <el-form-item  prop="imei" v-if="adminShow">
          <el-input v-model="queryParams.imei" :placeholder="$t('app.card.imeiPlaceholder')"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'imei')"></el-input>
        </el-form-item>
        <!-- <el-form-item  prop="groupNo" v-if="checkPermi(['card:group:network'])">
          <el-input v-model="queryParams.groupNo" placeholder="组网编号"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'groupNo')"></el-input>
        </el-form-item> -->
        <el-form-item  prop="groupStatus" v-if="checkPermi(['card:group:network'])">
          <el-select v-model="queryParams.groupStatus" filterable placeholder="组网状态" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'groupStatus')">
            <el-option value="1" label="已组网"></el-option>
            <el-option value="0" label="未组网"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="operatorNames" >
          <el-select v-model="queryParams.operatorNames" filterable multiple :placeholder="$t('app.card.operator')" @change="handleOperator" clearable @paste.native="handlePaste">
            <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardSourceId" v-if="adminShow">
          <el-select v-hasPermi="['card:cardSource']" v-model="queryParams.cardSourceId" filterable multiple placeholder="卡源" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardSourceId')">
            <el-option
              v-for="item in source"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardStatus" v-if="adminShow">
          <el-select v-model="queryParams.cardStatus" filterable placeholder="运营状态" @change="search" clearable multiple @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardStatus')">
            <el-option value="1" label="库存"></el-option>
            <el-option value="2" label="待激活"></el-option>
            <el-option value="3" label="可测试"></el-option>
            <el-option value="4" label="已激活"></el-option>
            <el-option value="5" label="已停机"></el-option>
            <el-option value="6" label="预销户"></el-option>
            <el-option value="7" label="已销户"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="showStatus">
          <el-select v-model="queryParams.showStatus" filterable :placeholder="$t('app.card.status')" @change="search" clearable multiple @paste.native="handlePaste" @input="(val) => handleInput(val, 'showStatus')">
            <el-option value="1" :label="$t('app.card.inventory')"></el-option>
            <el-option value="2" :label="$t('app.card.toBeActivated')"></el-option>
            <el-option value="3" :label="$t('app.card.testable')"></el-option>
            <el-option value="4" :label="$t('app.card.activated')"></el-option>
            <el-option value="5" :label="$t('app.card.stopped')"></el-option>
            <el-option value="6" :label="$t('app.card.preClosed')"></el-option>
            <el-option value="7" :label="$t('app.card.closed')"></el-option>
            <el-option value="8" :label="$t('app.card.paused')" v-show="adminShow"></el-option>
            <el-option value="9" :label="$t('app.card.reissued')" v-show="adminShow"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="distribution" >
          <el-select v-model="queryParams.distribution" filterable :placeholder="$t('app.card.distribution')" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'distribution')">
            <el-option
              v-for="item in assignData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="startIccid" v-if="adminShow">
          <el-input v-model="queryParams.startIccid" placeholder="开始号段"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'startIccid')"></el-input>
        </el-form-item>
        <el-form-item  prop="endIccid" v-if="adminShow">
          <el-input v-model="queryParams.endIccid" placeholder="结束号段"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'endIccid')"></el-input>
        </el-form-item>
        <el-form-item  prop="remark">
          <el-input v-model="queryParams.remark" :placeholder="$t('app.card.remark')"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'remark')"></el-input>
        </el-form-item>
        <el-form-item  prop="phone" v-if="adminShow">
          <el-input v-model="queryParams.phone" placeholder="联系方式"  @keyup.enter.native="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'phone')"></el-input>   
        </el-form-item>
        <el-form-item  prop="physicalTypeName" v-if="adminShow">
          <el-select v-model="queryParams.physicalTypeName" multiple placeholder="请选择物理卡类型" filterable clearable @change="search">
            <el-option
              v-for="dict in dict.type.card_physical_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.label"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item  prop="cardTypeSortName">
          <el-select v-model="queryParams.cardTypeSortName" multiple placeholder="请选择卡品类型" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardTypeSort')">
            <el-option
              v-for="dict in dict.type.card_type_sort_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardTypeName" v-if="adminShow">
          <el-select v-model="queryParams.cardTypeName" multiple placeholder="请选择卡类型" filterable clearable @change="search">
            <el-option
              v-for="dict in dict.type.card_type_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.label"
            ></el-option>
          </el-select>  
        </el-form-item>

        <el-form-item  prop="cardRequireName" v-if="adminShow">
          <el-select v-model="queryParams.cardRequireName" multiple placeholder="请选择卡测沉期" filterable @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardRequireName')">
            <el-option
              v-for="dict in dict.type.card_require_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.label"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item  prop="orientations" v-if="adminShow">
          <el-select v-model="queryParams.orientations" multiple placeholder="请选择卡定向类型" filterable @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'orientations')">
            <el-option
              v-for="item in orientationList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item  prop="gprsStatus" v-if="adminShow">
          <el-select v-model="queryParams.gprsStatus" placeholder="GPRS状态" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'gprsStatus')">
            <el-option
              v-for="item in gprsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardSort" v-if="adminShow">
          <el-select v-model="queryParams.cardSort" placeholder="卡分类" filterable @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardSort')">
            <el-option
              v-for="item in cardSorts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardMode" v-if="adminShow">
          <el-select v-model="queryParams.cardMode" placeholder="卡模式" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardMode')">
            <el-option label="流量卡模式" value="0"></el-option>
            <el-option label="流量池模式" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="needKyc" v-if="adminShow">
          <el-select v-model="queryParams.needKyc" placeholder="是否需要实名" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'needKyc')">
            <el-option
                v-for="item in needKycs"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardCertType" v-if="adminShow">
          <el-select v-model="queryParams.cardCertType" placeholder="实名类型" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'cardCertType')">
            <el-option
                v-for="item in cardCertTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="serviceProviderId" v-if="checkPermi(['system:provider:listAll'])">
          <el-select v-model="queryParams.serviceProviderId" placeholder="方案名称" filterable @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'serviceProviderId')">
            <el-option
                v-for="item in serviceProviderList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="salesmanUserId" v-if="adminShow">
          <el-select v-model="queryParams.salesmanUserId" filterable placeholder="业务员" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'salesmanUserId')">
            <el-option v-for="item in salemansData" :key="item.userId" :label="item.username + (!!item.realName?'-'+ item.realName:'')" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="speedRuleId" v-if="checkPermi(['product:limitSpeedValue:show'])">
          <el-select v-model="queryParams.speedRuleId" filterable clearable placeholder="限速值" @change="search">
            <el-option label="未设置" :value="0"></el-option>
            <el-option label="已设置" :value="9999"></el-option>
            <el-option
              v-for="item in speedRuleData"
              :key="item.id"
              :label="item.name+' ' + item.speedValue"
              :value="item.id">
              <span style="float: left">{{ item.name }} <em style="color:red;font-weight:700">限速 {{ item.speedValue }}</em></span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="groupId" v-if="checkPermi(['card:source:show'])">
          <el-select v-model="queryParams.groupId" filterable clearable placeholder="卡源群组" @change="search">
            <el-option
              v-for="item in sourceFlow"
              :key="item.groupId"
              :label="item.groupName"
              :value="item.groupId">
              <span style="float: left">{{ item.groupName }} <em style="color:red;font-weight:700" v-if="item.share == '1'"> 共享池</em></span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="selectTime" v-hasPermi="['card:select:time']">
          <el-select v-model="queryParams.selectTime" filterable :placeholder="$t('app.card.timeQueryMethod')" @change="search" clearable @paste.native="handlePaste" @input="(val) => handleInput(val, 'selectTime')" v-hasPermi="['card:select:time']">
            <el-option :label="$t('app.card.expireTime')" value="expireTime" v-hasPermi="['card:select:time']"></el-option>
            <el-option :label="$t('app.card.closeTime')" value="closeTime" v-if="adminShow"></el-option>
            <el-option :label="$t('app.card.openTime')" value="openTime" v-if="adminShow"></el-option>
            <el-option :label="$t('app.card.delTime')"  value="delTime" v-if="adminShow"></el-option>
            <el-option :label="$t('app.card.allocationTime')" value="lastAdminTransferTime" v-if="adminShow"></el-option>
            <el-option :label="$t('app.card.operatorActiveTime')" value="operatorActiveTime" v-if="adminShow"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="dateRange" v-hasPermi="['card:select:time']">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="dateRange"
            @change="search"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('app.card.startDate')"
            :end-placeholder="$t('app.card.endDate')">
          </el-date-picker>
        </el-form-item>
      </template>
      <el-form-item>
        <!-- <el-checkbox v-model="queryParams.shardingKey" :true-label=1 :false-label=0 style="margin-right:10px" @change="search">包含销卡</el-checkbox> -->
        <el-tooltip class="tooltip-button" :content="showSearch ? $t('app.common.hideSearch') : $t('app.common.showSearch')" placement="top">
          <el-button :icon="showSearch ? 'el-icon-arrow-up':'el-icon-arrow-down'" @click="showSearch=!showSearch"></el-button>
        </el-tooltip>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
        <el-button type="primary" @click="outTable" icon="el-icon-download"  v-hasPermi="['card:export']">{{ $t('app.common.export') }}</el-button>
        <el-button type="primary" @click="outFeeTable" icon="el-icon-download"  v-hasPermi="['card:export:fee']">续费导出</el-button>
        <el-button type="primary" @click="packageRenewal" icon="el-icon-first-aid-kit" v-hasPermi="['card:renewal']">{{ $t('app.card.packageRenewal') }}</el-button>
        <el-button type="primary" @click="handleOperationCard" icon="el-icon-coin" v-hasPermi="['card:updateCarrierStatus']" >批量修改运营状态</el-button>
        <el-dropdown @command="(command) => handleCommand(command)" style="margin-left: 10px" v-hasPermi="['card:allocation', 'card:clear','card:recycle','card:import','card:qrCode','card:setting','card:batchUpdate','card:speed','card:batchRemark','card:batchOrientationSetting']">

          <el-button type="primary">{{ $t('app.card.simConfiguration') }}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="handleCardAllocation" icon="el-icon-star-on"
                      v-hasPermi="['card:allocation']">{{ $t('app.card.cardAllocation') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardClear" icon="el-icon-brush"
                      v-hasPermi="['card:clear']">{{ $t('app.card.cardClear') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardRecycle" icon="el-icon-delete"
                      v-hasPermi="['card:recycle']">{{ $t('app.card.cardRecycle') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardImport" icon="el-icon-circle-plus"
                      v-hasPermi="['card:import']">{{ $t('app.card.cardImport') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardQrCode" icon="el-icon-brush"
                      v-hasPermi="['card:qrCode']">{{ $t('app.card.qrCode') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardBatchUpdate" icon="el-icon-thumb"
                      v-hasPermi="['card:batchUpdate']">{{ $t('app.card.batchUpdate') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardSpeed" icon="el-icon-s-flag"
                      v-hasPermi="['card:speed']">{{ $t('app.card.cardSpeedLimit') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardBatchRemark" icon="el-icon-document"
                      v-hasPermi="['card:batchRemark']">{{ $t('app.card.batchRemark') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardBatchSetting" icon="el-icon-setting"
            v-hasPermi="['card:batchSetting']">{{ $t('app.card.cardParameterConfig') }}</el-dropdown-item>
            <el-dropdown-item command="handleOrientationSetting" icon="el-icon-s-promotion"
            v-hasPermi="['card:batchOrientationSetting']">定向设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
    </el-form>
      <el-table 
        :data="tableData" 
        border
        id="out-table"
        ref="tableData"
        v-loading="loading"
        @sort-change="tableSortChange"
        @selection-change="handleSelectionChange"
        :empty-text="$t('app.common.noData')"
      >
      <el-table-column type="expand" v-if="adminShow">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="20">
                <!-- 缩小距离展示  避免影藏过多内容 -->
                <el-row>
                  <el-col :span="4">
                    <el-form-item label="物理卡类型：" >
                      <span>{{ props.row.cardPhysicalName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="卡品类型：" >
                      <span>{{ props.row.cardTypeSortName }}</span>
                    </el-form-item>
                  </el-col>
                  
                  <el-col :span="4">
                    <el-form-item label="卡类型：" >
                      <span>{{ props.row.cardTypeName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="卡定向类型：" >
                      <span>
                        <el-tag v-for="(name,index) in props.row.orientations" :key="index" style="margin: 3px;">{{name}}</el-tag>
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="卡测沉期：" >
                      <span>{{ props.row.cardRequireName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <el-form-item label="分配时间：" >
                      <span>{{ props.row.lastAdminTransferTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="激活时间：" >
                      <span>{{ props.row.activeTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="开户时间：" >
                      <span>{{ props.row.openTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="关机时间：" >
                      <span>{{ props.row.closeTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="销户时间：" >
                      <span>{{ props.row.delTime }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <el-form-item label="网络类型：" >
                      <span>{{ props.row.networkType }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="联系方式：" >
                      <span>{{ props.row.phone }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="是否实名：" >
                      <el-tag v-if="props.row.kycStatus =='0'" type="primary">未实名</el-tag>
                      <el-tag v-else-if="props.row.kycStatus =='1'" type="info">审核中</el-tag>
                      <el-tag v-else-if="props.row.kycStatus =='2'" type="success">审核通过</el-tag>
                      <el-tag v-else-if="props.row.kycStatus =='3'" type="danger">审核不通过</el-tag>
                      <el-tag v-else type="warning">注销实名</el-tag>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="初始速率：" >
                      <span v-if="props.row.initSpeedStatus =='0'">未限速</span>
                      <span v-else>{{props.row.initSpeedLabel}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="月初自动恢复：" >
                      <span v-if="props.row.initSpeedAutoRecovery =='1'">是</span>
                      <span v-if="props.row.initSpeedAutoRecovery =='2'">否</span>
                    </el-form-item>
                  </el-col>
                  
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <el-form-item label="APN：" >
                      <span>{{ props.row.apnName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="定向群号：" >
                      <span>{{ props.row.apnNo }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="群组ID：" >
                      <span>{{ props.row.groupId }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" v-if="checkPermi(['system:provider:listAll'])">
                    <el-form-item label="方案：" >
                      <span>{{ props.row.serviceProvider }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="组网成员：" >
                      <span>{{ props.row.groupIccid }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column prop="ids" :label="$t('app.card.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="agentName" :label="$t('app.card.agent')" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" sortable="custom" width="200px">
        <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="info(scope.row)">{{ scope.row.iccid }}</el-link>
            <el-tooltip class="item" effect="dark" :content="$t('app.common.copy')" placement="top-start">
                <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.iccid)"></i>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center" :sortable="adminShow ? 'custom' : false" width="150px">
        <template slot-scope="scope">
          <el-link v-if="adminShow && !!scope.row.agentName" type="primary" :underline="false" @click="showMobileH5(scope.row)">{{ scope.row.msisdn }}</el-link>
          <span v-else>{{ scope.row.msisdn }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('app.common.copy')" placement="top-start">
              <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.msisdn)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="imsi" label="IMSI" align="center" :sortable="adminShow ? 'custom' : false" width="140px"></el-table-column>
      <el-table-column prop="cardSourceName" :label="$t('app.card.cardSource')" v-if="checkPermi(['card:list:channel']) && adminShow" align="center" width="100px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operationName" :label="$t('app.card.operator')" align="center"></el-table-column>
      <el-table-column prop="cardStatus" :label="$t('app.card.operationStatus')" align="center" v-if="adminShow">
        <template slot-scope="{row}">
          <el-tag v-if="row.cardStatus =='已激活'">{{row.cardStatus}}</el-tag>
          <el-tag v-else-if="row.cardStatus =='库存'" type="success">{{row.cardStatus}}</el-tag>
          <el-tag v-else-if="row.cardStatus =='已停机'" type="danger">{{row.cardStatus}}</el-tag>
          <el-tag v-else-if="row.cardStatus =='待激活'" type="info">{{row.cardStatus}}</el-tag>
          <el-tag v-else type="warning">{{row.cardStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="showStatus" :label="$t('app.card.status')" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.showStatus =='已激活'">{{row.showStatus}}</el-tag>
          <el-tag v-else-if="row.showStatus =='库存'" type="success">{{row.showStatus}}</el-tag>
          <el-tag v-else-if="row.showStatus =='已停机'" type="danger">{{row.showStatus}}</el-tag>
          <el-tag v-else-if="row.showStatus =='待激活'" type="info">{{row.showStatus}}</el-tag>
          <el-tag v-else type="warning">{{row.showStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="speedStatus" :label="$t('app.card.packageSpeedLimit')" align="center" width="100px" v-if="adminShow">
        <template slot-scope="{row}">
          <span v-if="row.speedStatus =='0'">未限速</span>
          <span v-else>已限速</span>
          <p style="color:#C0C4CC">{{row.speedLimitValue =='未设置'?'单卡未设置':(row.speedLimitValue)}}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="speedLimitValue" label="单卡限速值" align="center" width="100px" v-if="adminShow"></el-table-column> -->
      <el-table-column prop="gprsStatus" label="GPRS" align="center" v-if="adminShow" width="100px">
        <template slot-scope="{row}">
          <span v-if="row.gprsStatus =='1'">{{ $t('app.card.enabled') }}</span>
          <span v-else>{{ $t('app.card.disabled') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="groupStatus" label="是否组网" align="center" v-if="checkPermi(['card:group:network'])" width="100px">
        <template slot-scope="{row}">
          <el-tag v-if="row.groupStatus =='1'" type="success">已组网</el-tag>
          <el-tag v-else type="info">未组网</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="monthFlow" :label="$t('app.card.monthlyFlow')" align="center" sortable="custom" v-if="checkPermi(['card:flow'])" width="120px"></el-table-column>
      <el-table-column prop="currentDayFlow" :label="$t('app.card.dailyUsage')" align="center" sortable="custom" v-if="adminShow" width="100px">
        <template slot-scope="{row}">
          {{mbToSize(row.currentDayFlow)}}
        </template>
      </el-table-column>
      <el-table-column prop="productMonthFlow" :label="$t('app.card.packageTotal')" align="center" sortable="custom" v-if="adminShow" width="120px"></el-table-column>
      <el-table-column prop="productUseFlow" :label="$t('app.card.packageUsed')" align="center" sortable="custom" v-if="adminShow" width="120px"></el-table-column>
      <el-table-column prop="productResidueFlow" :label="$t('app.card.packageRemaining')" align="center" sortable="custom" v-if="checkPermi(['card:flow:used'])" width="120px"></el-table-column>

      <!-- <el-table-column prop="integral" :label="$t('app.card.integral')" align="center" sortable="custom" v-if="adminShow" width="100px"></el-table-column> -->
      <el-table-column prop="expireTime" :label="$t('app.card.expireTime')" align="center" sortable="custom" :show-overflow-tooltip="true" width="120px"></el-table-column>
      <el-table-column prop="remark" :label="$t('app.card.remark')" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column :label="$t('app.common.operation')" align="center" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary" plain
              icon="el-icon-view"
              @click="info(scope.row)"
              v-hasPermi="['card:info']"
            >{{ $t('app.card.detail') }}</el-button>
            <el-button
              size="mini"
              type="primary" plain
              icon="el-icon-edit"
              @click="editRow(scope.row.iccid,scope.row)"
              v-hasPermi="['card:remark']"
            >{{ $t('app.card.remark') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="beizhu" ref="beizhu">
        <el-form-item label="备注内容:" prop="remark" :label-width="LabelWidth">
          <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item label="售后内容:" prop="saleRemark" :label-width="LabelWidth" v-if="adminShow">
          <el-input type="textarea" v-model="beizhu.saleRemark" autocomplete="off" style="width: 80%" placeholder="请输入售后内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
    <!-- 卡清除 -->
    <el-dialog :title="removalTitle" :visible.sync="openRemoval" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="removalForm" :model="removalForm" label-width="120px">
        <el-form-item label="类型" prop="fieldType" >
          <el-radio v-model="removalForm.fieldType" label="1" >ICCID</el-radio>
          <el-radio v-model="removalForm.fieldType" label="2" >MSISDN</el-radio>
        </el-form-item>
        <el-form-item :label="removalForm.fieldType == '1' ? 'ICCID列表' : 'MSISDN列表'" prop="iccids">
          <el-input v-model="removalForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8" @input="changeRemovalIccids"></el-input>
          <div class="card-num" v-if="removalIccidsCount>0"><span>总数：</span><span>{{removalIccidsCount}}</span></div>
        </el-form-item>
        <el-form-item :label="removalForm.fieldType == '1' ? 'ICCID范围' : 'MSISDN范围'" >
          <el-row>
            <el-col :span="11">
              <el-form-item prop="iccidStart">
                <el-input
                  v-model="removalForm.iccidStart"
                  clearable
                  placeholder="包含开始值"
                  @input = "changeRemovalIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="iccidEnd">
                <el-input
                  v-model="removalForm.iccidEnd"
                  clearable
                  placeholder="包含终止值"
                  @input = "changeRemovalIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="card-num" v-if="removalIccidRangeCount>0"><span>总数：</span><span>{{removalIccidRangeCount}}</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemovalForm" >确 定</el-button>
        <el-button @click="cancelRemoval">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 卡备注 -->
    <el-dialog :title="remarkTitle" :visible.sync="openRemark" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="remarkForm" :model="remarkForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="类型" prop="fieldType">
              <el-radio v-model="remarkForm.fieldType" label="1" >ICCID</el-radio>
              <el-radio v-model="remarkForm.fieldType" label="2" >MSISDN</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="remarkForm.fieldType == '1' ? 'ICCID列表' : 'MSISDN列表'" prop="iccids">
              <el-input v-model="remarkForm.iccids" type="textarea" clearable :placeholder="$t('app.card.cardRemark.iccidListPlaceholder')" rows="8" @input="changeRemarkIccids"></el-input>
              <div class="card-num" v-if="remarkIccidsCount>0"><span>总数：</span><span>{{remarkIccidsCount}}</span></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="remarkForm.fieldType == '1' ? 'ICCID范围' : 'MSISDN范围'" >
          <el-col :span="11">
            <el-form-item prop="startIccid">
              <el-input
                v-model="remarkForm.startIccid"
                clearable
                :placeholder="$t('app.card.cardRemark.includeStartValue')"
                @input = "changeRemarkIccidRange"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="endIccid">
              <el-input
                v-model="remarkForm.endIccid"
                clearable
                :placeholder="$t('app.card.cardRemark.includeEndValue')"
                @input = "changeRemarkIccidRange"
              ></el-input>
            </el-form-item>
          </el-col>
          <div class="card-num" v-if="remarkIccidRangeCount>0"><span>总数：</span><span>{{remarkIccidRangeCount}}</span></div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('app.card.cardRemark.batchRemarkContent')" prop="remark">
              <el-input v-model="remarkForm.remark" :placeholder="$t('app.card.cardRemark.remarkPlaceholder')" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarkForm" >{{ $t('app.common.confirm') }}</el-button>
        <el-button @click="cancelRemark">{{ $t('app.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 卡定向编辑 -->
    <el-dialog :title="orientationTitle" :visible.sync="openOrientation" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="orientationForm" :rules="orientationRule" :model="orientationForm" label-width="120px">
        <el-form-item label="类型" prop="fieldType" >
          <el-radio v-model="orientationForm.fieldType" label="1" >ICCID</el-radio>
          <el-radio v-model="orientationForm.fieldType" label="2" >MSISDN</el-radio>
        </el-form-item>
        <el-form-item label="卡定向类型" prop="orientation">
          <el-select v-model="orientationForm.orientation"  placeholder="请选择卡定向类型" filterable clearable>
            <el-option
              v-for="item in orientationData"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item :label="orientationForm.fieldType === '1' ? 'ICCID列表' : 'MSISDN列表' " prop="iccids">
          <el-input v-model="orientationForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8" @input="changeOrientationIccids"></el-input>
          <div class="card-num" v-if="orientationIccidsCount>0"><span>总数：</span><span>{{orientationIccidsCount}}</span></div>
        </el-form-item>
        <el-form-item :label="orientationForm.fieldType === '1' ? 'ICCID范围' : 'MSISDN范围' " >
          <el-row>
            <el-col :span="11">
              <el-form-item prop="iccidStart">
                <el-input
                  v-model="orientationForm.iccidStart"
                  clearable
                  placeholder="包含开始值"
                  @input = "changeOrientationIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="iccidEnd">
                <el-input
                  v-model="orientationForm.iccidEnd"
                  clearable
                  placeholder="包含终止值"
                  @input = "changeOrientationIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="card-num" v-if="orientationIccidRangeCount>0"><span>总数：</span><span>{{orientationIccidRangeCount}}</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitOrientationForm" >确 定</el-button>
        <el-button @click="openOrientation =false">取 消</el-button>

      </div>
    </el-dialog>

    <el-dialog title="充值页面预览" :visible.sync="mobileDialogVisible" width="480px" append-to-body :close-on-click-modal="false" :show-close="true">
      <div class="mobile-phone-container">
        <div class="mobile-phone">
          <div class="phone-status-bar">
            <div class="status-bar-left">{{ currentTime }}</div>
            <div class="status-bar-center">
              <i class="status-icon signal"></i>
              <i class="status-icon wifi"></i>
              <i class="status-icon battery"></i>
            </div>
          </div>
          <div class="phone-screen">
            <iframe 
              :src="mobileH5Url" 
              class="h5-iframe" 
              frameborder="0" 
              scrolling="yes"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
            ></iframe>
          </div>
          <div class="phone-home-bar">
            <div class="home-indicator"></div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { cardList , selectCount,listSpeedRule} from "@/api/api.js"; //流量卡列表
import { exportCard } from "@/api/api.js"; //流量卡导出
import { saveRemark } from "@/api/api.js"; //流量卡备注
import { cardSource } from "@/api/api.js"; //卡源
import { agentTreeList , usersSalemansList } from "@/api/api.js"; //代理商
import { cardBaseInfo } from "@/api/api.js";//卡类型
import { cardBatchSyncCard ,removalCard ,batchCardRemark ,sourceShareFlow,serviceProviderListAll,batchOrientationSetting} from "@/api/api.js";//批量更新
export default {
  dicts : [ 'card_physical_name','card_type_sort_name','card_type_name','card_require_name' ],
  name: "cards",
  data() {
    return {
      agentUserId: this.$route.params && this.$route.params.userId,
      division:[],
      loading: true,
      // 显示搜索条件
      showSearch: false,
      // 批量查询的显示
      batch:false,
      // 弹窗
      LabelWidth: "100px",
      add: true,
      dialog: false,
      title: "备注",
      beizhu:{},
      // 搜索
      dateRange:[],
      queryParams:{
        userIds:[],
        userId:undefined,
        iccid:undefined,
        msisdn:undefined,
        operatorNames:[],
        cardStatus:undefined,
        cardSourceId:undefined,
        showStatus:[],
        distribution:undefined,
        startIccid:undefined,
        endIccid:undefined,
        remark:undefined,
        phone:undefined,
        physicalTypeName:undefined,
        cardTypeSortName:undefined,
        cardTypeName:undefined,
        cardRequireName:undefined,
        cardType:undefined,
        orientations:undefined,
        cardTypeSort:undefined,
        gprsStatus:undefined,
        cardSort:undefined,
        selectTime:undefined,
        cardMode:undefined,
        needKyc:undefined,
        cardCertType:undefined,
        salesmanUserId:undefined,
        speedRuleId:undefined,
        groupId:undefined,
        serviceProviderId:undefined
      },
      initQueryParams:{
        userIds:[],
        userId:undefined,
        iccid:undefined,
        msisdn:undefined,
        operatorNames:[],
        cardStatus:undefined,
        cardSourceId:undefined,
        showStatus:[],
        distribution:undefined,
        startIccid:undefined,
        endIccid:undefined,
        remark:undefined,
        phone:undefined,
        physicalTypeName:undefined,
        cardTypeSortName:undefined,
        cardTypeName:undefined,
        cardRequireName:undefined,
        cardType:undefined,
        orientations:undefined,
        cardTypeSort:undefined,
        gprsStatus:undefined,
        cardSort:undefined,
        selectTime:undefined,
        cardMode:undefined,
        needKyc:undefined,
        cardCertType:undefined,
        salesmanUserId:undefined,
        speedRuleId:undefined,
        groupId:undefined,
        serviceProviderId:undefined
      },
      page: 1,
      pageSize: 20,
      total: 0,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      packageList:[],
      cardStatusList:[],
      cardUndistribution:false,
      operator:[
        {
          value: "中国电信",
          label: this.$t('app.card.chinaTelecom')
        },
        {
          value: "中国移动",
          label: this.$t('app.card.chinaMobile')
        },
        {
          value: "中国联通",
          label: this.$t('app.card.chinaUnicom')
        }
      ],
      tableData: [],
      // 代理商
      agentTree: [],
      // 来源
      source: [],
      orientationList:[],
      orientationData:[],
      assignData:[
        {
          value: 0,
          label: this.$t('app.card.unassigned')
        },
        {
          value: 1,
          label: this.$t('app.card.assigned') 
        },
      ],
      gprsList:[
        {
          value: '1',
          label: '已开启'
        }, {
          value: '0',
          label: '未开启'
        }
      ],
      cardSorts:[
        {
          value: '1',
          label: '测试套餐送流量'
        },
        {
          value: '2',
          label: '直接领取赠送流量'
        }
      ],
      needKycs:[
          {value:"0",label:'不需要'},
          {value:"1",label:'需要'}
      ],
      cardCertTypes:[
          {value:"1",label:'本地实名'},
          {value:"2",label:'运营商实名'}
      ],
      removalTitle:'卡清除',
      openRemoval:false,
      removalForm:{
        fieldType:'1',
        iccids:undefined,
        iccidStart:undefined,
        iccidEnd:undefined
      },
      //批量卡统计
      removalIccidsCount:0,
      //号段统计
      removalIccidRangeCount:0,
      openRemark:false,
      remarkTitle: this.$t('app.card.cardRemark.title'),
      remarkForm:{
        fieldType:'1',
        iccids:undefined,
        startIccid:undefined,
        endIccid:undefined,
        operatorType:'1',
        remark:undefined
      },
      remarkIccidsCount:0,
      remarkIccidRangeCount:0,
      salemansData:[],
      speedRuleData:[],
      sourceFlow:[],
      serviceProviderList:[],
      orientationTitle:'卡定向编辑',
      openOrientation:false,
      orientationForm:{
        fieldType:'1',
        orientation:undefined,
        iccids:'',
        iccidStart:undefined,
        iccidEnd:undefined
      },
      //批量卡统计
      orientationIccidsCount:0,
      //号段统计
      orientationIccidRangeCount:0,
      orientationRule:{
        orientation: [{ required: true, message: '请选择卡定向类型', trigger: 'blur' }],
      },
      mobileDialogVisible: false,
      mobileH5Url: '',
      currentTime: '',
      timeInterval: null,
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 多选单选的值
    handleSelectionChange(val){
      let arrlist = [];
      let cardStatusList = [];
      this.cardUndistribution = false;
      val.map(item=>{
        arrlist.push(item.iccid);
        cardStatusList.push(item.showStatus)
      })
      this.cardStatusList = cardStatusList;
      this.packageList = arrlist;
    },
    initServiceProviderList(){
      serviceProviderListAll().then(res=>{
        this.serviceProviderList = res.data.data
      })
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList({self:"1"}).then(res => {
        this.agentTree = res.data.data;
      });
    },
    //查找卡源列表
    handleCardSource(){
      let initNames = ['中国电信','中国移动','中国联通'];
      let params = {
        operatorNames: this.queryParams.operatorNames.length>0 ? this.queryParams.operatorNames : initNames
      }
      cardSource(params).then(res => {
        this.source = res.data.data;
        this.source.sort((a, b) => {
          return a.operationName.localeCompare(b.operationName, 'zh-CN', { sensitivity: 'accent' });
        });
      });
    },
    // 套餐续费
    packageRenewal(){
      let iccids = this.packageList;
      if(iccids.length == 0){
        //清空数据
        this.$store.dispatch('ClearProductIccids')
        this.$router.push("/order/renewal");
      }else{
        if(this.cardStatusList.includes("已销户") || this.cardStatusList.includes("预销户")  ){
          this.$message.error("状态为已销户活预销户的卡不允许充值，请取消！");
        }else{
          this.$store.dispatch('CacheProductIccids', iccids.join(","))
          this.$router.push("/order/renewal");
        }
      }
    },
    handleOperationCard(){
      //查看选中
      let iccids = this.packageList;
      if(iccids.length == 0){
        //清空数据
        this.$store.dispatch('ClearIccids')
      }else{
        this.$store.dispatch('CacheIccids', iccids.join(","))
      }
      this.$router.push("/card/carrierStatus");
    },
    batchUpdate(){
      if(this.packageList == 0){
        return this.$message.error('请选择要更新的卡号');
      }else{
        let params = {
          iccids:this.packageList
        }
        cardBatchSyncCard(params).then(res=>{
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "批量更新",
              type: "success",
              offset:30
            });
            this.initData()
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    handleCommand(command){
      switch (command) {
        case "handleCardAllocation":
          this.handleCardAllocation();
          break;
        case "handleCardClear":
          this.handleCardClear();
          break;
        case "handleCardRecycle":
          this.handleCardRecycle();
          break;
        case "handleCardImport":
          this.handleCardImport();
          break;
        case "handleCardQrCode":
          this.handleCardQrCode();
          break;
        case "handleCardBatchUpdate":
          this.handleCardBatchUpdate();
          break;
        case "handleCardSpeed":
          this.handleCardSpeed();
          break;
        case "handleCardBatchRemark":
          this.handleCardBatchRemark();
          break;
        case "handleCardBatchSetting":
          this.handleCardBatchSetting();
          break;
        case "handleOrientationSetting":
          this.handleOrientationSetting();
        default:
          break;
      }
    },
    //卡分配
    handleCardAllocation(){
      this.$router.push({name:"transfer",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡清除
    handleCardClear(){
      this.openRemoval =true;
      this.removalIccidRangeCount = 0
      this.removalForm.iccids = this.packageList.toString().replaceAll(",","\n")
      let arrIccids = this.removalForm.iccids ? this.removalForm.iccids.split("\n") : []
      this.removalIccidsCount = arrIccids.filter(item=>!!item).length
    },
    //卡定向编辑
    handleOrientationSetting(){
      this.openOrientation =true;
      this.orientationIccidsCount = 0
      let iccids = this.packageList.toString().replaceAll(",","\n")
      this.orientationForm.iccids = iccids.length > 0 ? iccids : this.orientationForm.iccids
      let arrIccids = this.orientationForm.iccids ? this.orientationForm.iccids.split("\n") : []
      this.orientationIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeOrientationIccidRange()
    },
    changeRemovalIccids(){
      let arrIccids = this.removalForm.iccids ? this.removalForm.iccids.split("\n") : []
      this.removalIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeRemovalIccidRange(){
      this.removalIccidRangeCount = 0
      let fieldType = this.removalForm.fieldType
      if(!!this.removalForm.iccidStart && !!this.removalForm.iccidEnd){
        if(this.removalForm.fieldType === '1'  && this.removalForm.iccidStart.length>18 && this.removalForm.iccidEnd.length>18){
          let startIccid = this.removalForm.iccidStart
          let endIccid =  this.removalForm.iccidEnd
          selectCount({fieldType,startIccid,endIccid}).then(res=>{
            this.removalIccidRangeCount = res.data.data
          })
        }
        if(this.removalForm.fieldType === '2'  && this.removalForm.iccidStart.length>12 && this.removalForm.iccidEnd.length>12){
          let startIccid = this.removalForm.iccidStart
          let endIccid =  this.removalForm.iccidEnd
          selectCount({fieldType,startIccid,endIccid}).then(res=>{
            this.removalIccidRangeCount = res.data.data
          })
        }  
      }
    },

    changeOrientationIccids(){
      let arrIccids = this.orientationForm.iccids ? this.orientationForm.iccids.split("\n") : []
      this.orientationIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeOrientationIccidRange(){
      this.orientationIccidRangeCount = 0
      let fieldType = this.orientationForm.fieldType
      if(!!this.orientationForm.iccidStart && !!this.orientationForm.iccidEnd){
            if(this.orientationForm.fieldType === '1'  && this.orientationForm.iccidStart.length>18 && this.orientationForm.iccidEnd.length>18){
              let startIccid = this.orientationForm.iccidStart
              let endIccid =  this.orientationForm.iccidEnd
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.orientationIccidRangeCount = res.data.data
              })
            }
            if(this.orientationForm.fieldType === '2'  && this.orientationForm.iccidStart.length>12 && this.orientationForm.iccidEnd.length>12){
              let startIccid = this.orientationForm.iccidStart
              let endIccid =  this.orientationForm.iccidEnd
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.orientationIccidRangeCount = res.data.data
              })
            }
      }
    },

    changeRemarkIccids(){
      let arrIccids = this.remarkForm.iccids ? this.remarkForm.iccids.split("\n") : []
      this.remarkIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeRemarkIccidRange(){
      this.remarkIccidRangeCount = 0
      let fieldType = this.remarkForm.fieldType
      if(!!this.remarkForm.startIccid && !!this.remarkForm.endIccid){
            if(this.remarkForm.fieldType === '1'  && this.remarkForm.startIccid.length>18 && this.remarkForm.endIccid.length>18){
              let startIccid = this.remarkForm.startIccid
              let endIccid =  this.remarkForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.remarkIccidRangeCount = res.data.data
              })
            }
            if(this.remarkForm.fieldType === '2'  && this.remarkForm.startIccid.length>12 && this.remarkForm.endIccid.length>12){
              let startIccid = this.remarkForm.startIccid
              let endIccid =  this.remarkForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.remarkIccidRangeCount = res.data.data
              })
            }
      }
    },

    //卡回收
    handleCardRecycle(){
      this.$router.push({name:"recovery",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡导入
    handleCardImport(){
      this.$router.push("/card/import");
    },
    //二维码
    handleCardQrCode(){
      this.$router.push({name:"codeQR",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡批量更新
    handleCardBatchUpdate(){
      this.batchUpdate()
    },
    //卡限速
    handleCardSpeed(){
      this.$router.push({name:"speed",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    handleCardBatchRemark(){  
      this.openRemark =true;
      this.remarkIccidsCount = 0
      this.remarkForm.iccids = this.packageList.toString().replaceAll(",","\n")
      let arrIccids = this.remarkForm.iccids ? this.remarkForm.iccids.split("\n") : []
      this.remarkIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeRemarkIccidRange()
    },
    handleCardBatchSetting(){
      //查看选中
      let iccids = this.packageList;
      if(iccids.length == 0){
        //清空数据
        this.$store.dispatch('ClearIccids')
      }else{
        this.$store.dispatch('CacheIccids', iccids.join(","))
      }
      this.$router.push("/device/cardSetting");
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order == "descending" ? "desc" : "asc";
      if(val.prop == 'id'){
        this.sortName = 'id'
      }else if(val.prop == 'monthFlow'){
        this.sortName = 'monthFlow'
      }else if(val.prop == 'currentDayFlow'){
        this.sortName = 'currentDayFlow'
      }else if(val.prop == 'expireTime'){
        this.sortName = 'expireTime'
      }else if(val.prop == 'integral'){
        this.sortName = 'integral'
      }else if(val.prop == 'productMonthFlow'){
        this.sortName = 'productMonthFlow'
      }else if(val.prop == 'productUseFlow'){
        this.sortName = 'productUseFlow'
      }else if(val.prop == 'productResidueFlow'){
        this.sortName = 'productResidueFlow'
      }else if(val.prop == 'iccid'){
        this.sortName = 'iccid'
      }else if(val.prop == 'msisdn'){
        this.sortName = 'msisdn'
      }
      if(!val.order){
        this.sortOrder = undefined
        this.sortName = undefined
      }
      this.initData()
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    handleOperator(){
      this.handleCardSource()
      this.search()
    },
    // 重置
    resetQuery() {
      this.queryParams = Object.assign({}, this.initQueryParams);
      this.$refs.queryForm.resetFields();
      this.iccidShow = false;
      this.dateRange = [];
      this.sortOrder = '';
      this.sortName = '';
      this.$refs.tableData.clearSort();
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.$refs.myCascader.$refs.panel.activePath = [];
      this.handleCardSource()
      this.search();
    },
    // 导出
    outTable() {
      this.queryParams.outFee = "0";
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange),
        order: this.sortOrder,
        sort: this.sortName,
      };
      if(this.queryParams.operatorNames.length == 0){
        params.operatorNames = ['中国移动','中国联通','中国电信']
      }
      this.$alert("确定导出流量卡吗？", "流量卡导出", {
        confirmButtonText: "确定"
      }).then(() => {
        exportCard(params).then(res => {
          this.$notify({
              title: "成功",
              message: "列表导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
        });
      });
    },
    outFeeTable(){
      this.queryParams.outFee = "1";
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange),
        order: this.sortOrder,
        sort: this.sortName,
      };
      if(this.queryParams.operatorNames.length == 0){
        params.operatorNames = ['中国移动','中国联通','中国电信']
      }
      this.$alert("确定导出续费卡吗？", "续费卡导出", {
        confirmButtonText: "确定"
      }).then(() => {
        exportCard(params).then(res => {
          this.$notify({
              title: "成功",
              message: "列表导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
        });
      });
    },
    // 关闭弹窗
    dialogClose() {
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    cancelDialog() {
      this.dialog = false;
    },
    // 备注
    saveDialog() {
      let params = {
        remark:this.beizhu.remark,
        iccid:this.beizhu.iccid,
        saleRemark:this.beizhu.saleRemark
      };
      saveRemark(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData()
        }
      })
    },
    // 添加备注
    editRow(iccid,row) {
      this.beizhu = {};
      this.dialog = true;
      this.title = "备注";
      this.beizhu = Object.assign({}, row);
    },
    // 详情
    info(row) {
      if(row.internationalFlag){
        this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
      } else {
        this.$router.push({path:"/card/detail",query:{iccid: row.iccid}});
      }
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    // 获取列表
    initData() {
      this.loading = true;
      let params = {
        model:{
					... this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      cardList(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
            item.cardStatus = this.inventoryStatusType(item.cardStatus);
            item.showStatus = this.inventoryStatusType(item.showStatus);
            if(item.expireTime ){
              item.expireTime = item.expireTime.substr(0,10);
            }else{
              item.expireTime = null;
            }
            if(item.monthFlow == 0 || item.monthFlow == null){
              item.monthFlow = 0 + 'Byte'
            }else if(1024 > item.monthFlow > 0){
              item.monthFlow = this.formatDecimal(item.monthFlow,2) + "M"
            }else if(item.monthFlow >=1024){
              item.monthFlow = this.formatDecimal(item.monthFlow/1024,2) + "G"
            }
          })
          this.loading = false;
      });
    },
    batchQuery(){
      this.batch = this.batch == false ? true : false
    },
    // 卡类型数据
    cardRequirements(){
      cardBaseInfo().then(res=>{
        this.orientationList = res.data.data.orientations;
        this.orientationData = res.data.data.orientations;
        this.orientationList.sort((a, b) => b.name.localeCompare(a.name));
        this.orientationData.sort((a, b) => b.name.localeCompare(a.name));
      })
    },
    mbToSize(mb){
        const sizes = ['M', 'GB', 'TB'];
        if (mb === 0) return '0M';
        if (mb > 0 && mb<= 1 ) return mb +' M';
        const i = Math.floor(Math.log(mb) / Math.log(1024));
        return (mb / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    },
    //清除卡提交
    submitRemovalForm(){
        removalCard(this.removalForm).then(res => {
            if(res.data.code ==200){
              this.$message.success("清除成功，任务中心查看进度");
              this.openRemoval = false;
              this.$refs['removalForm'].resetFields();
            }else{
              this.$message.error(res.data.message);
            }
        });
    },
    submitRemarkForm(){
      let { iccids } = this.remarkForm;
      let data = {
        ...this.remarkForm,
        operatorType:'1',
        iccids:iccids ? iccids.split("\n") : []
      };
      batchCardRemark(data).then(res => {
        this.$notify({
          title: "成功",
          message: "批量备注成功，请在任务中心查看进度",
          type: "success",
          offset:30
        });
        this.$refs['remarkForm'].resetFields();
        this.openRemark = false;
        this.remarkIccidsCount = 0
        this.remarkIccidRangeCount = 0
        this.initData()
      });

    },
    //取消取消
    cancelRemoval(){
      this.openRemoval =false;
      this.$refs['removalForm'].resetFields();
    },
    cancelRemark(){
      this.openRemark =false;
      this.$refs['remarkForm'].resetFields();
    },
    getUsersSalemans(){
       usersSalemansList({}).then(res=>{
         this.salemansData = res.data.data;
       }) 
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },
    handlePaste(event) {
      // 确保粘贴事件正常工作
      event.stopPropagation();
    },
    handleInput(value, field) {
      // 根据输入框的字段名更新对应的值
      if (this.queryParams.hasOwnProperty(field)) {
        this.queryParams[field] = value;
      }
    },
    selectSpeedRules(){
      if(this.adminShow){
        listSpeedRule().then(res=>{
          this.speedRuleData = res.data.data
        })
      }
    },
    //流量池
    selectSourceFlow(){
      sourceShareFlow({all:'1'}).then(res=>{
        this.sourceFlow = res.data.data
        this.sourceFlow.map((item,index) => {
          item.groupName = item.groupName + '(' + item.groupId + ')';
        })

      })
    },
    submitOrientationForm(){
      this.$refs['orientationForm'].validate((valid) => {
        if (valid) {
          batchOrientationSetting(this.orientationForm).then(res => {
            if(res.data.code ==200){
              this.$message.success("定向成功，任务中心查看进度");
              this.orientationIccidsCount = 0
              this.orientationIccidRangeCount = 0
              this.orientationForm.iccids = ''
              this.orientationForm.iccidStart = undefined
              this.orientationForm.iccidEnd = undefined
              this.openOrientation = false;
              this.initData()
            }else{
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    showMobileH5(row) {
      this.mobileH5Url = `https://iot.juzi1688.cn/dist/#/info?iccid=${row.iccid}`;
      this.mobileDialogVisible = true;
      this.updateTime();
      this.timeInterval = setInterval(() => {
        this.updateTime();
      }, 1000);
    },
    updateTime() {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      this.currentTime = `${hours}:${minutes}`;
    },
    closeMobileDialog() {
      this.mobileDialogVisible = false;
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
      }
    }

  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'cards'){
          let userId = this.$route.params && this.$route.params.userId;
          this.queryParams.userIds = !!userId ? [userId] : this.queryParams.userIds;

          let salesmanUserId = this.$route.params && this.$route.params.salesmanUserId;
          this.queryParams.salesmanUserId = !!salesmanUserId ?salesmanUserId : this.queryParams.salesmanUserId;

          let startIccid = this.$route.params && this.$route.params.startIccid;
          let endIccid = this.$route.params && this.$route.params.endIccid;
          this.queryParams.startIccid = !!startIccid ? startIccid : this.queryParams.startIccid;
          this.queryParams.endIccid = !!endIccid ? endIccid : this.queryParams.endIccid;
          this.initData();
        }
      },
      // 深度观察监听
      deep: true
    },
    mobileDialogVisible(val) {
      if (!val && this.timeInterval) {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
      }
    }
  },
  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  },
  created() {
    let userId = this.$route.params && this.$route.params.userId;
    let salesmanUserId = this.$route.params && this.$route.params.salesmanUserId;

    this.queryParams.userIds = !!userId ? [userId] : this.queryParams.userIds
    this.queryParams.salesmanUserId = !!salesmanUserId ? salesmanUserId : this.queryParams.salesmanUserId

    let startIccid = this.$route.params && this.$route.params.startIccid;
    let endIccid = this.$route.params && this.$route.params.endIccid;
    this.queryParams.startIccid = !!startIccid ? startIccid : this.queryParams.startIccid;
    this.queryParams.endIccid = !!endIccid ? endIccid : this.queryParams.endIccid;

    // 支持从组网统计页携带运营商参数跳转
    let operatorName = this.$route.query && this.$route.query.operatorName;
    if (!!operatorName) {
      this.queryParams.operatorNames = [operatorName]
    }

    this.initData();
    this.cardRequirements();
    this.handleAgentTreeList();
    // 查找卡源列表
    this.handleCardSource();
    this.selectSpeedRules()
    if(this.adminShow){
      this.getUsersSalemans()
      this.selectSourceFlow()
      if(this.checkPermi(['system:provider:listAll'])){
        this.initServiceProviderList()
      }
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
  .table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }
  .card-num{
    height: 20px;
    line-height: 20px;
    span:nth-of-type(2){
      color:red
    }
  }

  .mobile-phone-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 20px;
  }

  .mobile-phone {
    width: 370px;
    height: 640px;
    background: #000;
    border-radius: 40px;
    box-shadow: 
      0 20px 60px rgba(0, 0, 0, 0.3),
      inset 0 0 20px rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
  }

  .phone-status-bar {
    height: 44px;
    background: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
  }

  .status-bar-left {
    flex: 1;
  }

  .status-bar-center {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    align-items: center;
  }

  .status-icon {
    width: 18px;
    height: 12px;
    display: inline-block;
    background: #fff;
    border-radius: 2px;
  }

  .status-icon.signal {
    clip-path: polygon(0 100%, 20% 0, 40% 60%, 60% 20%, 80% 80%, 100% 40%);
    width: 20px;
    height: 12px;
  }

  .status-icon.wifi {
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    width: 16px;
    height: 16px;
  }

  .status-icon.battery {
    width: 24px;
    height: 11px;
    border: 2px solid #fff;
    border-radius: 3px;
    position: relative;
    background: #4caf50;
  }

  .status-icon.battery::after {
    content: '';
    position: absolute;
    right: -4px;
    top: 2px;
    width: 3px;
    height: 5px;
    background: #fff;
    border-radius: 0 1px 1px 0;
  }

  .phone-screen {
    height: calc(100% - 88px);
    background: #fff;
    margin: 0 8px;
    border-radius: 32px;
    overflow: hidden;
    position: relative;
  }

  .h5-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .phone-home-bar {
    height: 44px;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home-indicator {
    width: 130px;
    height: 5px;
    background: #fff;
    border-radius: 3px;
    opacity: 0.6;
  }

</style>